module.exports = __webpack_public_path__ + "media/images/flags/4x3/nld-9d4a525fe7fa5a78231c7ee7ecf86915.svg";